import { UploadInterface } from "cloudinary-core";

type CloudinaryPreset = {
  uploadPreset: string;
} & Partial<UploadInterface>;

const fileExtensions = {
  video: ["mp4", "mov", "avi", "wmv", "flv", "mpeg", "mpg"],
  image: ["jpg", "jpeg", "png", "pdf"],
};

export const cloudinaryPresets: Record<string, CloudinaryPreset> = {
  image: {
    uploadPreset: "h1raksv4",
    clientAllowedFormats: [...fileExtensions.image, ...fileExtensions.video],
    maxImageFileSize: 20 * 1024 * 1024, // 20MB
  },
  brandImages: {
    uploadPreset: "rta_brand_images",
    clientAllowedFormats: ["jpg", "jpeg", "png", "webp"],
    maxImageFileSize: 5 * 1024 * 1024, // 5MB
  },
  attachments: {
    uploadPreset: "jyehcpv4",
  },
  printReady: {
    uploadPreset: "rta_print_ready_artwork",
    resourceType: "raw",
  },
};
